import React from 'react';
import Icon, { CameraOutlined } from '@ant-design/icons';

const CloseIconSvg = () => (<svg width='1em' height='1em' fill='currentColor' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 3.41375L7.91375 0.5L9.5 2.08625L6.58625 5L9.5 7.91375L7.91375 9.5L5 6.58625L2.08625 9.5L0.5 7.91375L3.41375 5L0.5 2.08625L2.08625 0.5L5 3.41375Z' />
  </svg>
);
export const CloseIcon = (props: any) => <Icon component={CloseIconSvg} {...props} />;